import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import './PlanEntryOptionsModal.scss'
import PlaylistSelector from '../playlist/PlaylistSelector'
import ShareModalContent from '../shareModal/ShareModalContent'
import AloModal from '../AloModal'
import DuplicateEntryPrompt from '../playlist/modals/DuplicateEntryPrompt'
class PlanEntryOptionsModal extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      display: '',
      duplicatePlaylist: null
    }

    this.changeDisplay = this.changeDisplay.bind(this)
    this.handlePlaylistSelected = this.handlePlaylistSelected.bind(this)
    this.addToPlaylist = this.addToPlaylist.bind(this)
  }

  addToPlaylist (playlist) {
    this.props.onPlaylistSelect(playlist)
    this.props.onHide()
  }

  changeDisplay (display, options = {}) {
    this.setState({ display, ...options })
  }

  handlePlaylistSelected (playlist) {
    if (this.props.planEntryInPlaylist(playlist)) {
      this.changeDisplay('DUPLICATE', { duplicatePlaylist: playlist })
    } else {
      this.addToPlaylist(playlist)
    }
  }

  getDisplayedView () {
    switch (this.state.display) {
      case 'PLAYLIST':
        return (
          <div className='PlanEntryOptionsModal__playlist'>
            <Modal.Header>Add To Playlist</Modal.Header>
            <PlaylistSelector
              playlists={this.props.playlists}
              onSelect={this.handlePlaylistSelected}
              isMarked={this.props.planEntryInPlaylist}
            />
          </div>
        )
      case 'SHARE':
        return (
          <div className='PlanEntryOptionsModal__share'>
            <ShareModalContent
              item='Class'
              urlToShare={this.props.planEntry.planEntryUrl}
              onHide={this.props.onHide}
            />
          </div>
        )
      case 'DUPLICATE':
        return (
          <DuplicateEntryPrompt
            onCancel={() => {
              this.changeDisplay('PLAYLIST')
            }}
            onConfirm={() => {
              this.addToPlaylist(this.state.duplicatePlaylist)
            }}
            playlist={this.state.duplicatePlaylist}
            entry={this.props.planEntry}
          />
        )
      default:
        return (
          <div className='PlanEntryOptionsModal__mainMenu'>
            <ul>
              <li>
                <a href={this.props.planEntry.planProduct.firstCoachUrl()}>
                  Go to instructor
                </a>
              </li>
              <li>
                <a href={this.props.planEntry.planProduct.url()}>
                  Go to program
                </a>
              </li>
              <li
                onClick={() => {
                  this.changeDisplay('PLAYLIST')
                }}
              >
                <a href='#'>Add to playlist</a>
              </li>
              <li
                onClick={() => {
                  this.changeDisplay('SHARE')
                }}
              >
                <a href='#'>Share</a>
              </li>
              <li
                onClick={() => {
                  this.props.onHide()
                  this.props.onDelete()
                }}
              >
                <a href='#'>Delete</a>
              </li>
            </ul>
          </div>
        )
    }
  }

  render () {
    const view = this.getDisplayedView()

    return (
      <AloModal show={this.props.show} onHide={this.props.onHide}>
        {view}
      </AloModal>
    )
  }
}

PlanEntryOptionsModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  playlists: PropTypes.array,
  onPlaylistSelect: PropTypes.func,
  planEntry: PropTypes.object,
  planEntryInPlaylist: PropTypes.func
}

export default PlanEntryOptionsModal
